<ng-container *ngIf="focusAreasConfig$ | async as focusAreasConfig">
  <div class="actions">
    <app-ag-grid-options [configStoreTableName]="configStoreTableName">
    </app-ag-grid-options>
  </div>

  <ag-grid-angular
    columnHoverHighlight
    rowHoverHighlight
    class="ag-theme-adap ag-sticky"
    rowClass="ag-no-border"
    [rowData]="focusAreasConfig$ | async"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [components]="components"
    domLayout="normal"
    configStore
    [configStoreTableName]="configStoreTableName"
    columnSizeStrategy="sizeColumnsToFit"
    suppressScrollOnNewData
  >
  </ag-grid-angular>
</ng-container>
